import { IFigures } from "../../models/response/IFigures";

export const FiguresInfoState:IFigures = {
    Id : 0,
    TestTakenCount : 0,
    CountriesCount : 0,
    CompaniesCount : 0,
    CoachesCount : 0,
    TrainersCount : 0
}